import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is a live context layer?",
    a: "It is a structured, source-backed model of how your software works. AntAtlas connects features, execution flows, conditions, state, dependencies, contracts, and tests so an AI coding agent can start with system context instead of rebuilding it from scratch.",
  },
  {
    q: "How is AntAtlas different from code search or RAG?",
    a: "Search retrieves files that match a query. AntAtlas models how a feature behaves and how its parts connect, including relationships that share no obvious keyword or direct call. The model becomes an index for selecting the right context for the task.",
  },
  {
    q: "Can it trace a feature across multiple repositories?",
    a: "Yes. Feature Trails connect the parts of one behavior across services and repositories. Every cross-repository handoff is anchored on both sides, while private or unknown parts of a flow remain explicit instead of being guessed.",
  },
  {
    q: "How can an agent trust the context?",
    a: "Meaningful facts are tied to evidence in the source: repository, commit, file, symbol, and location. Confidence and known gaps stay visible, so the agent can verify a claim before relying on it.",
  },
  {
    q: "Does AntAtlas replace our coding agent?",
    a: "No. Claude Code, Cursor, Codex, or another coding agent still plans and implements the change. AntAtlas supplies the system understanding and task-specific context that agent would otherwise have to rediscover.",
  },
  {
    q: "Can teams share the same knowledge graph?",
    a: "Yes. AntAtlas provides an MCP server that gives compatible AI tools and coding agents access to the same source-backed knowledge graph. Teams share one view of how the system works, so context discovered by one team can help every other team instead of staying trapped in separate tools or conversations.",
  },
  {
    q: "Does AntAtlas store our source code or repository data?",
    a: "No. AntAtlas does not store your source code or repository data. Your system graphs are generated and stored on the client side, so your codebase stays under your control.",
  },
];

const FAQ = () => (
  <section className="section-padding" id="faq">
    <div className="container-narrow">
      <div className="text-center mb-16">
        <p className="text-xs font-medium uppercase tracking-widest text-accent mb-3">
          FAQ
        </p>
        <h2 className="heading-lg mb-4">Common questions</h2>
      </div>

      <Accordion type="single" collapsible className="w-full">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`}>
            <AccordionTrigger className="text-left text-base font-semibold">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
